import {
    GET_CANCELLATION_POLICY,
    CREATE_CANCELLATION_POLICY,
    UPDATE_CANCELLATION_POLICY,
    DELETE_CANCELLATION_POLICY
} from './action-types';
import {
    GET_CANCELLATION_POLICY_URL,
    CREATE_CANCELLATION_POLICY_URL,
    UPDATE_CANCELLATION_POLICY_URL,
    DELETE_CANCELLATION_POLICY_URL
} from '../utils/api-url';
import { postCall , getCall  } from "../utils/network.util";


export const getCancellationPolicyDetails = (operator_code) => {
    return {
        type: GET_CANCELLATION_POLICY,
        payload: {
            url: GET_CANCELLATION_POLICY_URL,
            api: postCall,
            apiPayload:{
                operatorCode:operator_code,
            }
        }
    }
}


export const createCancellationPolicy= ({
    deductionAmount,
    fromValue,
    is_percentage,
    operatorCode,
    operatorName,
    policyPattern,
    toValue
},onSuccess) => {
    return {
        type: CREATE_CANCELLATION_POLICY,
        payload: {
            url: CREATE_CANCELLATION_POLICY_URL,
            api: postCall,
            apiPayload:{
                operatorCode:operatorCode,
                is_percentage:is_percentage,
                fromValue:fromValue,
                deductionAmount:deductionAmount,
                operatorName:operatorName,
                policyPattern:policyPattern,
                toValue:toValue
            },
            onSuccess:onSuccess
        }
    }
}

export const updateCancellationPolicy= ({
    deductionAmount,
    fromValue,
    is_percentage,
    operatorCode,
    operatorName,
    policyPattern,
    toValue,
    id,
},onSuccess) => {
    return {
        type: UPDATE_CANCELLATION_POLICY,
        payload: {
            url: UPDATE_CANCELLATION_POLICY_URL,
            api: postCall,
            apiPayload:{
                operatorCode:operatorCode,
                is_percentage:is_percentage,
                fromValue:fromValue,
                deductionAmount:deductionAmount,
                operatorName:operatorName,
                policyPattern:policyPattern,
                toValue:toValue,
                id:id
            },
            onSuccess:onSuccess
        }
    }
}

export const deleteCancellationPolicy= (id,operator_code,onSuccess) => {
    return {
        type: DELETE_CANCELLATION_POLICY,
        payload: {
            url: DELETE_CANCELLATION_POLICY_URL,
            api: postCall,
            apiPayload:{
                operatorCode:operator_code,
                id : id
            },
            onSuccess:onSuccess
        }
    }
}
